import uiReducer from './commonUiReducer'
import netReducer from './commonNetReducer'

export default {
  commonUiReducer: uiReducer,
  commonNetReducer: netReducer,
}
